import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Power, Beaker } from "lucide-react";

const STATUS_INFO = {
  enabled: { color: "bg-emerald-600", label: "Activat" },
  disabled: { color: "bg-zinc-700", label: "Dezactivat" },
  beta: { color: "bg-amber-600", label: "Beta" },
};

export default function IDGAppsTab() {
  const [apps, setApps] = useState([]);
  const load = () => api.get("/idg/apps").then((r) => setApps(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (app) => {
    try { 
      await api.post(`/idg/apps/${app.id}/toggle`); 
      toast.success(`Modulul "${app.name}" a fost comutat!`); 
      load(); 
    }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-4" data-testid="idg-apps-tab">
      <div>
        <h3 className="tf-section-title font-chakra text-sm font-bold uppercase tracking-wider text-[var(--tf-primary)]">
          Aplicații & Module Platformă
        </h3>
        <p className="text-xs text-zinc-400 mt-0.5">
          Activează sau dezactivează modulele platformei INDUNGI. Modulele dezactivate sunt ascunse din meniu și blocate.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-3.5">
        {apps.map((a) => {
          const isEnabled = a.status === "enabled";
          const info = STATUS_INFO[a.status] || STATUS_INFO.disabled;
          return (
            <div 
              key={a.id} 
              className="bg-[#0b0e15] border border-white/15 p-4 flex items-start justify-between gap-3 transition-colors hover:border-white/30" 
              data-testid={`idg-app-row-${a.key}`}
            >
              <div className="flex items-start gap-3 min-w-0">
                <div 
                  className={`w-1.5 self-stretch ${isEnabled ? "bg-emerald-500" : "bg-zinc-700"}`} 
                />
                <div className="min-w-0 space-y-1">
                  <div className="flex items-center gap-2">
                    <h4 className="font-bold text-white text-sm font-chakra tracking-wide truncate">{a.name}</h4>
                    <span className={`px-2 py-0.5 text-[9px] font-black uppercase tracking-wider ${info.color} text-white`}>
                      {info.label}
                    </span>
                    {a.status === "beta" && <Beaker className="w-3.5 h-3.5 text-amber-400" />}
                  </div>
                  <p className="text-xs text-zinc-400 leading-snug line-clamp-2">{a.description}</p>
                  <div className="text-[10px] font-mono text-zinc-500">
                    v{a.version} · key=<span className="text-zinc-300 font-bold">{a.key}</span>
                  </div>
                </div>
              </div>

              <button
                onClick={() => toggle(a)}
                className={`tf-btn-skew px-3.5 py-2 text-xs font-black flex items-center gap-1.5 flex-shrink-0 ${
                  isEnabled 
                    ? "bg-red-600 hover:bg-red-500 text-white" 
                    : "tf-btn-primary"
                }`}
                data-testid={`idg-app-toggle-${a.key}`}
              >
                <span>
                  <Power className="w-3.5 h-3.5 mr-1" />
                  {isEnabled ? "Dezactivează" : "Activează"}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

